<script setup>
import { useI18n } from 'vue-i18n';
import SummaryDetailHeatmap from './SummaryDetailHeatmap.vue';

defineProps({
  entityType: {
    type: String,
    required: true,
    validator: value => ['agent', 'team', 'inbox', 'label'].includes(value),
  },
  entityId: {
    type: [String, Number],
    required: true,
  },
  filters: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col gap-4">
    <SummaryDetailHeatmap
      :entity-type="entityType"
      :entity-id="entityId"
      :filters="filters"
      :metric="
        ['agent', 'team'].includes(entityType)
          ? 'started_cycles_count'
          : 'conversations_count'
      "
      :title="
        ['agent', 'team'].includes(entityType)
          ? t('SUMMARY_REPORTS.HEATMAPS.STARTED_CYCLES')
          : t('SUMMARY_REPORTS.HEATMAPS.CONVERSATIONS')
      "
      color-scheme="green"
    />
    <SummaryDetailHeatmap
      :entity-type="entityType"
      :entity-id="entityId"
      :filters="filters"
      metric="resolutions_count"
      :title="t('SUMMARY_REPORTS.HEATMAPS.RESOLUTIONS')"
      color-scheme="blue"
    />
  </div>
</template>
